<template>
  <div class="container-md container-app p-0 ">
    <div class="wrapper">
      <div class="header"><h1>{{$t("layout_impostazioni")}}</h1></div>
      <div class="content content-full">
        <div class="title">{{$t("impostazioni_lingue")}}</div>
        <div class="sezione">
          <div class="row justify-content-center">
            <div class="col-6 col-md-4 mb-3" v-for="lingua in lingue_attive" :key="lingua.codice">
              <div class="text-center">
                <img :src="flagSrc(lingua.codice)" height="32" class="mb-3"><br>
                <button
                  class="btn"
                  :class="languageButtonClass(lingua.codice)"
                  @click="changeLanguage(lingua.codice)"
                >
                  {{ lingua.nome || lingua.codice.toUpperCase() }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="title">{{$t("impostazioni_notifiche")}}</div>
        <div class="p-3 text-muted f13" v-if="!userAuthenticated">
          {{$t("impostazioni_login_required")}}
        </div>
        <div class="d-flex align-items-center justify-content-between border-bottom p-3">
          <div class="flex-grow-1">
            <b class="f4">{{$t("impostazioni_ordini")}}</b><br>
            <div class="f13">{{$t("impostazioni_ordini_txt")}}</div>
          </div>
          <div class="text-success text-uppercase text-center font-weight-bold f14" style="width: 70px;">{{$t("impostazioni_sempre")}}<br>{{$t("impostazioni_attive")}}</div>
        </div>
        <div class="d-flex align-items-center justify-content-between border-bottom p-3">
          <div class="flex-grow-1">
            <b class="f4">{{$t("impostazioni_sconto")}}</b><br>
            <div class="f13">{{$t("impostazioni_sconto_txt")}}</div>
          </div>
          <div class="d-flex justify-content-end" style="width: 70px;">
            <toggle-button color="#8BD69E"
                           :sync="true"
                           :value="settings.f_notifiche_a"
                           :disabled="!userAuthenticated || settings_loading || settings_saving.a"
                           :labels="{checked: $t('impostazioni_si'), unchecked: $t('impostazioni_no')}"
                           @change="toggleNotificheA"/>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-between border-bottom p-3">
          <div class="flex-grow-1">
            <b class="f4">{{$t("impostazioni_suggerimenti")}}</b><br>
            <div class="f13">{{$t("impostazioni_suggerimenti_txt")}}</div>
          </div>
          <div class="d-flex justify-content-end" style="width: 70px;">
            <toggle-button color="#8BD69E"
                           :sync="true"
                           :value="settings.f_notifiche_b"
                           :disabled="!userAuthenticated || settings_loading || settings_saving.b"
                           :labels="{checked: $t('impostazioni_si'), unchecked: $t('impostazioni_no')}"
                           @change="toggleNotificheB"/>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import {getRestaurantInfo} from "../api/restaurant";
import {setNotificheA, setNotificheB, setUserLocalization, status} from "../api/account";

export default {
  name: "Impostazioni",
  data() {
    return {
      lingue_attive: [],
      settings: {
        f_notifiche_a: true,
        f_notifiche_b: true
      },
      settings_loading: false,
      settings_saving: {
        a: false,
        b: false
      },
      selected_flag_codes: ['it', 'fr', 'es', 'de']
    }
  },
  created() {
    this.fetchLanguages();
    this.fetchSettings();
  },
  computed: {
    ...mapState('localization', {
      language: state => state.language
    }),
    ...mapState('restaurant', {
      id_ristorante: state => state.id
    }),
    ...mapState('auth', {
      user: state => state
    }),
    ...mapGetters('auth', {
      userAuthenticated: 'authenticated'
    })
  },
  watch: {
    language: function () {
      this.fetchSettings();
    },
    userAuthenticated: function () {
      this.fetchSettings();
    },
    id_ristorante: function () {
      this.fetchLanguages();
      this.fetchSettings();
    }
  },
  methods: {
    ...mapActions('global', [
      'showModalErrors'
    ]),
    ...mapActions('localization', [
      'setLanguage'
    ]),
    languageButtonClass(code) {
      if (!code) return 'btn-default';
      return this.language && code.toLowerCase() === this.language.toLowerCase() ? 'btn-primary' : 'btn-default';
    },
    flagSrc(code) {
      const normalized = (code || '').toLowerCase();
      const isSelected = this.language && normalized === this.language.toLowerCase();
      const suffix = isSelected ? '-sel' : '';
      return `/img/be/flags/${normalized}${suffix}.png`;
    },
    changeLanguage(code) {
      if (!code || (this.language && code.toLowerCase() === this.language.toLowerCase())) {
        return;
      }

      this.setLanguage(code);

      if (!this.userAuthenticated) {
        return;
      }

      if (!this.id_ristorante || !this.user.api_key) {
        return;
      }

      setUserLocalization(code, {
        id_ristorante: this.id_ristorante,
        api_key: this.user.api_key,
        cod_lingua: code
      }).catch(({messages}) => {
        if (messages) {
          this.showModalErrors({
            title: 'IMPOSTAZIONI',
            errors: messages
          });
        }
      });
    },
    fetchLanguages() {
      if (!this.id_ristorante) return;
      getRestaurantInfo(this.language, {
        id_ristorante: this.id_ristorante
      }).then((response) => {
        this.lingue_attive = response.lingue_attive || [];
      }).catch(({messages}) => {
        if (messages) {
          this.showModalErrors({
            title: 'IMPOSTAZIONI',
            errors: messages
          });
        }
      });
    },
    fetchSettings() {
      if (!this.userAuthenticated || !this.id_ristorante || !this.user.api_key) {
        return;
      }

      this.settings_loading = true;
      status(this.language, {
        id_ristorante: this.id_ristorante,
        api_key: this.user.api_key
      }).then((response) => {
        this.settings.f_notifiche_a = !!response.f_notifiche_a;
        this.settings.f_notifiche_b = !!response.f_notifiche_b;
      }).catch(({messages}) => {
        if (messages) {
          this.showModalErrors({
            title: 'IMPOSTAZIONI',
            errors: messages
          });
        }
      }).finally(() => {
        this.settings_loading = false;
      });
    },
    toggleNotificheA(event) {
      if (!this.userAuthenticated) return;
      if (!this.id_ristorante || !this.user.api_key) return;

      const nextValue = !!(event && event.value);
      const prevValue = this.settings.f_notifiche_a;
      this.settings.f_notifiche_a = nextValue;
      this.settings_saving.a = true;

      setNotificheA(this.language, {
        id_ristorante: this.id_ristorante,
        api_key: this.user.api_key,
        f_notifiche_a: nextValue ? 1 : 0
      }).catch(({messages}) => {
        this.settings.f_notifiche_a = prevValue;
        if (messages) {
          this.showModalErrors({
            title: 'IMPOSTAZIONI',
            errors: messages
          });
        }
      }).finally(() => {
        this.settings_saving.a = false;
      });
    },
    toggleNotificheB(event) {
      if (!this.userAuthenticated) return;
      if (!this.id_ristorante || !this.user.api_key) return;

      const nextValue = !!(event && event.value);
      const prevValue = this.settings.f_notifiche_b;
      this.settings.f_notifiche_b = nextValue;
      this.settings_saving.b = true;

      setNotificheB(this.language, {
        id_ristorante: this.id_ristorante,
        api_key: this.user.api_key,
        f_notifiche_b: nextValue ? 1 : 0
      }).catch(({messages}) => {
        this.settings.f_notifiche_b = prevValue;
        if (messages) {
          this.showModalErrors({
            title: 'IMPOSTAZIONI',
            errors: messages
          });
        }
      }).finally(() => {
        this.settings_saving.b = false;
      });
    }
  }
}
</script>
